import { render, staticRenderFns } from "./AssetsModal.vue?vue&type=template&id=121fa00b&scoped=true&"
import script from "./AssetsModal.vue?vue&type=script&lang=js&"
export * from "./AssetsModal.vue?vue&type=script&lang=js&"
import style0 from "./AssetsModal.vue?vue&type=style&index=0&id=121fa00b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121fa00b",
  null
  
)

export default component.exports